import { Model, attr, fk } from 'redux-orm';

import ActionTypes from '../constants/ActionTypes';

export default class extends Model {
  static modelName = 'AlertOccur';

  static fields = {
    id: attr(),
    name: attr(),
    alertSettingId: fk({
      to: 'AlertSetting',
      as: 'alertSetting',
      relatedName: 'alertOccurs',
    }),
    deviceId: fk({
      to: 'Device',
      as: 'device',
      relatedName: 'alertOccurs',
    }),
    itemId: fk({
      to: 'Item',
      as: 'item',
      relatedName: 'alertOccurs',
    }),
    lineId: fk({
      to: 'Line',
      as: 'line',
      relatedName: 'alertOccurs',
    }),
    siteId: fk({
      to: 'Site',
      as: 'site',
      relatedName: 'alertOccurs',
    }),
    isDataFetching: attr({
      getDefault: () => false,
    }),
    alertDatas: attr({
      getDefault: () => [],
    }),
  };

  static reducer({ type, payload }, AlertOccur) {
    switch (type) {
      case ActionTypes.ALERTS_OCCUR_FETCH_SUCCEEDED:
        payload.alerts.forEach((alert) => {
          AlertOccur.upsert(alert);
        });

        break;
      case ActionTypes.ALERT_UPDATED:
        if (payload.alert.resTime === null) {
          AlertOccur.upsert(payload.alert);
        } else {
          AlertOccur.withId(payload.alert.id).delete();
        }

        break;
      case ActionTypes.ALERT_DATA_FETCH_REQUESTED:
        if (AlertOccur.withId(payload.data.alertId)) {
          AlertOccur.withId(payload.data.alertId).update({
            isDataFetching: true,
          });
        }
        break;
      case ActionTypes.ALERT_DATA_FETCH_SUCCEEDED:
        if (AlertOccur.withId(payload.alertId)) {
          AlertOccur.withId(payload.alertId).update({
            isDataFetching: false,
            alertDatas: payload.alertDatas,
          });
        }
        break;
      default:
    }
  }

  static getOrderedQuerySet() {
    return this.orderBy('id');
  }
}
